<template>
  <div>
    <div class="w-100 d-inline-block position-relative py-3">
      <div class="container autoContent">
        <div class="row g-4 justify-content-center">
          
          <!-- Card 1: 01 & 02 -->
          <div class="col-xl-6 col-lg-6 col-md-12 mb-4 d-flex">
            <div class="w-100 d-flex flex-column rounded-4 p-4 p-xl-5" style="background-color: #FFF2E6;">
              <div class="w-100 mb-4">
                <h3 class="fw-bold filson-black-family text-black mb-3">
                  <span class="text-size-32 me-2">01.</span> <span class="text-size-24">{{ firstHeading }}</span>
                </h3>
                <p class="text-size-14 text-black family-inter-light text-lh-large mb-0">
                  {{ firstContent }}
                </p>
              </div>
              <div class="w-100 mb-5">
                <h3 class="fw-bold filson-black-family text-black mb-3">
                  <span class="text-size-32 me-2">02.</span> <span class="text-size-24">{{ secondHeading }}</span>
                </h3>
                <p class="text-size-14 text-black family-inter-light text-lh-large mb-0">
                  {{ secondContent }}
                </p>
              </div>
              <div class="w-100 mt-auto text-center">
                <img class="img-fluid rounded-4 shadow-sm w-100" v-lazy="firstImageSrc" alt="Booking App Mockup">
              </div>
            </div>
          </div>

          <!-- Card 2: 03 & 04 -->
          <div class="col-xl-6 col-lg-6 col-md-12 mb-4 d-flex">
            <div class="w-100 d-flex flex-column rounded-4 p-4 p-xl-5 bg-white">
              <div class="w-100 mb-4">
                <h3 class="fw-bold filson-black-family text-black mb-3">
                  <span class="text-size-32 me-2">03.</span> <span class="text-size-24">{{ thirdHeading }}</span>
                </h3>
                <p class="text-size-14 text-black family-inter-light text-lh-large mb-0">
                  {{ thirdContent }}
                </p>
              </div>
              <div class="w-100 mb-5">
                <h3 class="fw-bold filson-black-family text-black mb-3">
                  <span class="text-size-32 me-2">04.</span> <span class="text-size-24">{{ fourHeading }}</span>
                </h3>
                <p class="text-size-14 text-black family-inter-light text-lh-large mb-0">
                  {{ fourContent }}
                </p>
              </div>
              <div class="w-100 mt-auto text-center">
                <img class="img-fluid rounded-4 shadow-sm w-100" v-lazy="secondImageSrc" alt="Van">
              </div>
            </div>
          </div>

          <!-- Card 3: 05 & 06 -->
          <div class="col-xl-6 col-lg-6 col-md-12 mb-4 d-flex">
            <div class="w-100 d-flex flex-column rounded-4 p-4 p-xl-5 bg-white">
              <div class="w-100 mb-4">
                <h3 class="fw-bold filson-black-family text-black mb-3">
                  <span class="text-size-32 me-2">05.</span> <span class="text-size-24">{{ fiveHeading }}</span>
                </h3>
                <p class="text-size-14 text-black family-inter-light text-lh-large mb-0">
                  {{ fiveContent }}
                </p>
              </div>
              <div class="w-100 mb-5">
                <h3 class="fw-bold filson-black-family text-black mb-3">
                  <span class="text-size-32 me-2">06.</span> <span class="text-size-24">{{ sixHeading }}</span>
                </h3>
                <p class="text-size-14 text-black family-inter-light text-lh-large mb-0">
                  {{ sixContent }}
                </p>
              </div>
              <div class="w-100 mt-auto text-center">
                <img class="img-fluid rounded-4 shadow-sm w-100" v-lazy="threeImageSrc" alt="Grooming Dog">
              </div>
            </div>
          </div>

          <!-- Card 4: 07 & 08 -->
          <div class="col-xl-6 col-lg-6 col-md-12 mb-4 d-flex">
            <div class="w-100 d-flex flex-column rounded-4 p-4 p-xl-5" style="background-color: #FFF2E6;">
              <div class="w-100 mb-4">
                <h3 class="fw-bold filson-black-family text-black mb-3">
                  <span class="text-size-32 me-2">07.</span> <span class="text-size-24">{{ sevenHeading }}</span>
                </h3>
                <p class="text-size-14 text-black family-inter-light text-lh-large mb-0">
                  {{ sevenContent }}
                </p>
              </div>
              <div class="w-100 mb-5">
                <h3 class="fw-bold filson-black-family text-black mb-3">
                  <span class="text-size-32 me-2">08.</span> <span class="text-size-24">{{ eightHeading }}</span>
                </h3>
                <p class="text-size-14 text-black family-inter-light text-lh-large mb-0">
                  {{ eightContent }}
                </p>
              </div>
              <div class="w-100 mt-auto text-center">
                <img class="img-fluid rounded-4 shadow-sm w-100" v-lazy="fourImageSrc" alt="Payment Terminal">
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block py-3" style="background-color: #F9F9F9;">
      <div class="container autoContent">
        <div class="row align-items-center">
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6 mb-4 mb-xl-0 text-center text-xl-start">
            <div class="w-100 w-xl-75 d-inline-block mx-auto">
              <img class="img-fluid" v-lazy="reachoutImageSrc" alt="grooming at home, grooming for all pets, professional grooming team">
            </div>
          </div>
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block text-center text-xl-start ps-xl-4">
              <p class="mb-2 text-size-14 nav-color family-filson-bold text-uppercase fw-bold text-full-14">
                {{ reachoutLabel }}
              </p>
              <h2 class="text-black fw-bold filson-black-family margin-bottom-3" style="font-size: 40px; line-height: 1.2;">
                {{ reachoutHeading }}
              </h2>
              <p class="mb-4 text-size-14 text-muted family-inter-light text-lh-large text-full-13" style="max-width: 600px;">
                {{ reachoutContentPrimary }}
              </p>
              <p class="mb-0 text-size-14 text-muted family-inter-light text-lh-large text-full-13" style="max-width: 600px;">
                {{ reachoutContentSecondary }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block 
    padding-bottom-4">
      <div class="container autoContent">
        <div class="row margin-top-4">
          
          <!-- LEFT SIDE: Why choose us text and list -->
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6 mb-5 mb-xl-0 pe-xl-5">
            <div class="w-100 d-inline-block">
              <h2 class="text-black fw-bold filson-black-family w-100 margin-bottom-3" style="font-size: 32px; line-height: 1.2;">
                Why You Should Choose<br>Us
              </h2>
              <p class="mb-4 text-size-14 text-muted family-inter-light text-lh-large text-full-13">
                {{ chooseUsContent }}
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <p class="margin-bottom-2 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true" style="font-size: 18px;"></i>
                <span class="float-start w-92 text-full-13 text-size-14">Skilled groomers.</span>
              </p>
              <p class="margin-bottom-2 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 float-start margin-top-1" aria-hidden="true" style="font-size: 18px;"></i>
                <span class="float-start w-92 text-full-13 text-size-14">24/7 customer support</span>
              </p>
              <p class="margin-bottom-2 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true" style="font-size: 18px;"></i>
                <span class="float-start w-92 text-full-13 text-size-14">High-quality product</span>
              </p>
              <p class="margin-bottom-2 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true" style="font-size: 18px;"></i>
                <span class="float-start w-92 text-full-13 text-size-14">Pet-friendly environment</span>
              </p>
              <p class="margin-bottom-2 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true" style="font-size: 18px;"></i>
                <span class="float-start w-92 text-full-13 text-size-14">Mobile grooming services</span>
              </p>
              <p class="margin-bottom-2 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true" style="font-size: 18px;"></i>
                <span class="float-start w-92 text-full-13 text-size-14">Free consultation</span>
              </p>
              <p class="margin-bottom-2 text-black text-size-14 text-capitalize family-inter-light w-100 d-inline-block text-full-13">
                <i class="fa fa-check-circle-o nav-color margin-right-2 margin-top-1 float-start" aria-hidden="true" style="font-size: 18px;"></i>
                <span class="float-start w-92 text-full-13 text-size-14">Highly affordable</span>
              </p>
            </div>
          </div>

          <!-- RIGHT SIDE: Accordion / FAQ -->
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div
              class="w-100 d-inline-block pets-collapse margin-bottom-3"
              v-for="(faqItem, faqIdx) in faqItems"
              :key="'faq-' + faqIdx"
              :class="faqIdx < faqItems.length - 1 ? 'border-bottom pb-3' : ''"
            >
              <a
                class="family-filson-bold text-black text-size-15 fw-bold w-100 d-flex align-items-center text-decoration-none"
                type="button"
                :data-bs-toggle="faqIdx === 0 ? null : 'collapse'"
                :data-bs-target="faqIdx === 0 ? null : '#collapseFaq' + faqIdx"
                aria-expanded="false"
                :aria-controls="'collapseFaq' + faqIdx"
                @click="onFaqHeadingClick($event, faqIdx)"
              >
                <i class="fa fa-check-circle-o nav-color me-3" aria-hidden="true" style="font-size: 20px;"></i>
                <span class="text-full-14 text-size-14">{{ faqItem.question }}</span>
              </a>
              <div :class="['collapse mt-3 ms-4 ps-2', { show: faqIdx === 0 && faqFirstPanelOpen }]" :id="'collapseFaq' + faqIdx">
                <p class="mb-0 text-size-14 text-muted family-inter-light text-lh-large text-full-13">
                  {{ faqItem.answer }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block 
    bg-orange">
      <div class="container autoContent">
        <div class="row margin-top-1 margin-bottom-0">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
        <li class="float-start margin-right-2">
          <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
            <i class="fa fa-home nav-color" aria-hidden="true"></i>
            Home  /
          </a>
        </li>
        <li class="float-start">
          <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
            Services
          </a>
        </li>
      </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "schduleAppointmentComponent",
    data() {
      return {
        faqFirstPanelOpen: true,

        firstHeading: 'Schedule',
        firstContent:
          "Your pet's grooming appointment is only with a few clicks away. Select the time windows that work best for your pet’s grooming requirements. We provide various scheduling choices as well you may book a grooming appointment on selected days.",
        secondHeading: 'Appointment Confirmation',
        secondContent:
          'When appointment is confirmed, you will receive prompt confirmation via email or text, such as the date, time, services selected, and groomer designated for your appointment.You can simply modify or cancel the appointment if needed, with reminders sent as the appointment date arrives.',
        thirdHeading: 'Groomer Arrival',
        thirdContent:
          'Our trained pet groomer will arrive on time at your location, fully prepared with pet safe grooming equipment and supplies. We ensure a smooth experience for both you and your pet; you’ll be notified when the groomer is on their way, so you can be prepared.',
        fourHeading: 'Consultation',
        fourContent:
          "The groomer will hold a brief consultation to discuss your pet's grooming requirements to let you satisfy. Here you can talk about any issues or preferences you have about your pet's care, such as haircut styles or skin sensitivities. Our goal is to deliver a mobile grooming service that leaves your pet appearing and feeling amazing.",
        fiveHeading: 'Grooming Session',
        fiveContent:
          'During the grooming procedure, your pet will be treated with attention to detail.Our groomers conduct everything with full attention. We focus your pet\'s comfort, making sure they have a happy and joyful experience. Our varieties of mobile grooming services make sure your pet stays tidy, fresh, and clean.',
        sixHeading: 'Customer Communication',
        sixContent:
          'We believe in keeping you updated on the grooming process. If you have any queries or want to know how things are going, our staff will keep you informed.You can also interact directly with the groomer to verify that your requirements are satisfied. We ensure straightforward and transparent communication in order to guarantee your happiness.',
        sevenHeading: 'Payment',
        sevenContent:
          "After your pet's grooming session, you can easily make a payment with any of the methods that suit you the best, either online, card or cash.We have made the payment procedure as simple as possible. You will receive detailed receipts and may see your payment history through your online account.",
        eightHeading: 'Maintenance',
        eightContent:
          'Following each session, we offer you with customize suggestions on the guidelines to groom your pet in between sessions. This might include brushing techniques and suggested grooming products, and guidance on how to keep your pet\'s hair, skin, and nails in good shape of specific breed. We will also guide you on when yours pet need next grooming session.',

        firstImage: null,
        secondImage: null,
        threeImage: null,
        fourImage: null,

        reachoutLabel: 'Reach out to Dubai',
        reachoutHeading: 'Pet Groomers for personal assistance',
        reachoutContentPrimary:
          "At Lush Groom, we vow to never disappoint our clientele by giving priority to their convenience and comfort while they trust us with our dog grooming services. Therefore, we have made it easy to let you schedule your dog's grooming appointment without any hassle.",
        reachoutContentSecondary:
          'To get more insights on scheduling an appointment, just pay a visit to our website, go to the appointment booking section and there you have your dog grooming appointment at one touch on a screen!',
        reachoutImage: null,

        chooseUsContent:
          'Choosing us for your pets grooming needs is the best decision you can make for the well-being and happiness of your furry companions. At LushGroom, we pride ourselves on offering a personalized and caring experience that goes beyond a simple grooming session. Here are some compelling reasons why you should choose us:',

        apiFaq: [],
        defaultFaq: [
          {
            question: 'How can I schedule a grooming appointment?',
            answer:
              'You can easily schedule an appointment! All you need to do is click on our booking tab and select your suitable time and date, pick out the services from the options, and add it to your cart. Or you can contact us through our email and phone number.',
          },
          {
            question: 'Are your groomers professionally trained?',
            answer:
              'Yes, all of our groomers are highly trained and experienced in handling pets of all breeds and kind. They’re skilled in gentle grooming techniques and ensure to provide a safe and comfortable experience for your pet.',
          },
          {
            question: 'How long does a grooming session last?',
            answer:
              'The grooming session depends on your pet’s requirements and the services. It typically lasts anywhere from 30 minutes to 2 hours.',
          },
          {
            question: 'Do grooming sessions require our presence as well?',
            answer:
              'We recommend your presence for a first meeting with the groomer when using our mobile grooming services.',
          },
          {
            question: 'Can I cancel or postpone my appointment in case of an emergency?',
            answer:
              'Yes, you can cancel or reschedule an appointment, please contact us using the information provided when you booked us. Please notify at least 4 to 6 hours before.',
          },
          {
            question: 'Is grooming safe for my pet?',
            answer:
              'Absolutely! Our groomers make sure to let your pet feel happy and safe throughout the grooming session. We use pet-friendly, mild, and gentle products to ensure your pet’s health.',
          },
        ],
      };
    },
    computed: {
      iconClass() {
        return this.faqFirstPanelOpen ? "fa fa-check-circle-o text-green" : "fa fa-check-circle-o text-black";
      },
      firstImageSrc() {
        return this.firstImage ? this.$getImageUrl(this.firstImage) : require('@/assets/images/pet-grooming-equipment-pet-grooming-franchise-pet-grooming-prices.svg');
      },
      secondImageSrc() {
        return this.secondImage ? this.$getImageUrl(this.secondImage) : require('@/assets/images/pets-transport-image.svg');
      },
      threeImageSrc() {
        return this.threeImage ? this.$getImageUrl(this.threeImage) : require('@/assets/images/work-pets-groom-image.svg');
      },
      fourImageSrc() {
        return this.fourImage ? this.$getImageUrl(this.fourImage) : require('@/assets/images/dog-love-image.svg');
      },
      reachoutImageSrc() {
        return this.reachoutImage ? this.$getImageUrl(this.reachoutImage) : require('@/assets/images/grooming-at-home-grooming-for-all-pets-professional-grooming-team.png');
      },
      faqItems() {
        if (this.apiFaq && this.apiFaq.length) return this.apiFaq;
        return this.defaultFaq;
      },
    },
    methods: {
      onFaqHeadingClick(e, faqIdx) {
        if (faqIdx === 0) {
          e.preventDefault();
          this.faqFirstPanelOpen = !this.faqFirstPanelOpen;
        }
      },
      async fetchServicePage() {
        try {
          const res = await this.$axios.post('/get-service-page', {
            website_name: this.activeWebsiteName,
          });
          const page = res?.data?.service_page;
          if (!page) return;

          this.firstHeading = page.first_heading || this.firstHeading;
          this.firstContent = page.first_content || this.firstContent;
          this.secondHeading = page.second_heading || this.secondHeading;
          this.secondContent = page.second_content || this.secondContent;
          this.thirdHeading = page.third_heading || this.thirdHeading;
          this.thirdContent = page.third_content || this.thirdContent;
          this.fourHeading = page.four_heading || this.fourHeading;
          this.fourContent = page.four_content || this.fourContent;
          this.fiveHeading = page.five_heading || this.fiveHeading;
          this.fiveContent = page.five_content || this.fiveContent;
          this.sixHeading = page.six_heading || this.sixHeading;
          this.sixContent = page.six_content || this.sixContent;
          this.sevenHeading = page.seven_heading || this.sevenHeading;
          this.sevenContent = page.seven_content || this.sevenContent;
          this.eightHeading = page.eight_heading || this.eightHeading;
          this.eightContent = page.eight_content || this.eightContent;

          this.firstImage = page.first_image || null;
          this.secondImage = page.second_image || null;
          this.threeImage = page.three_image || null;
          this.fourImage = page.four_image || null;

          this.reachoutHeading = page.reachout_heading || this.reachoutHeading;
          this.reachoutContentPrimary = page.reachout_content || this.reachoutContentPrimary;
          this.reachoutContentSecondary = ''; // keep second paragraph slot, optional later
          this.reachoutImage = page.reachout_image || null;

          this.chooseUsContent = page.choose_us_content || this.chooseUsContent;

          const rawFaq = page.faq;
          this.apiFaq = Array.isArray(rawFaq)
            ? rawFaq
                .map((f) => ({ question: f.question || '', answer: f.answer || '' }))
                .filter((f) => f.question || f.answer)
            : [];
        } catch (e) {
          console.error('fetchServicePage', e);
        }
      },
    },
    mounted() {
      const name = (this.$countryName || '').toString().trim();
      if (name) {
        this.reachoutLabel = String(this.reachoutLabel).replace(/dubai/gi, name);
      }
      this.fetchServicePage();
    },
    watch: {
      activeWebsiteName() {
        this.fetchServicePage();
      },
    },
  };
</script>

<style scoped>
.text-lh-large {
  line-height: 1.8;
}
</style>


